import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';
import logo from '../../assets/images/logo/logo.png';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';

const footerSections = [
  {
    title: 'Products',
    links: [
      { label: 'Printing Paper', href: '/products?category=printing-paper' },
      { label: 'Photo Paper', href: '/products?category=photo-paper' },
      { label: 'Binding Materials', href: '/products?category=binding' },
      { label: 'School Supplies', href: '/products?category=school' },
      { label: 'Office Stationery', href: '/products?category=office' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Bulk Orders', href: '/bulk-orders' },
    
    ],
  },
  {
    title: 'Help',
    links: [
      { label: 'Contact Us', href: '/contact' },
     
    ],
  },
];

const Footer = () => {
  return (
    <footer className="bg-white border-t">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="space-y-6">
            <Link to="/" className="block">
              <img 
                src={logo} 
                alt="MyExpress Limited Logo"
                className="w-auto h-24 md:h-32 mb-4"
              />
            </Link>
            <p className="text-gray-600 text-sm">
              Your one-stop shop for premium printing papers, stationery, and office supplies. 
              Quality products for all your printing and documentation needs.
            </p>
            <div className="space-y-4">
              <div className="flex items-start text-gray-600">
                <Phone size={16} className="mr-2 mt-1 flex-shrink-0" />
                <div className="text-sm">
                  <div>0706 788802</div>
                  
                </div>
              </div>
              <div className="flex items-center text-gray-600">
                <Mail size={16} className="mr-2 flex-shrink-0" />
                <span className="text-sm">sales@myexpresslimited.com</span>
              </div>
              <div className="flex items-start text-gray-600">
                <MapPin size={16} className="mr-2 mt-1 flex-shrink-0" />
                <span className="text-sm">
                  Charles Rubia Rd, Crossroad House
                </span>
              </div>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title}>
              <h3 className="font-semibold text-gray-900 mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-gray-600 hover:text-primary-500 transition-colors text-sm"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-semibold text-gray-900 mb-3">Business Hours</h4>
            <div className="text-sm text-gray-600 space-y-1">
              <p>Monday - Saturday: 8:00 AM - 6:00 PM</p>
              <p>Sunday & Public Holidays: Closed</p>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 mb-3">Bulk Orders</h4>
            <p className="text-sm text-gray-600">
              Special discounts available for schools, businesses, and large quantity orders. 
              <Link to="/bulk-orders" className="text-brand-blue-500 hover:text-brand-blue-600 ml-1">
                Request a quote
              </Link>
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-gray-900 mb-3">Quality Guarantee</h4>
            <p className="text-sm text-gray-600">
              All our papers and stationery products come with a quality guarantee. 
              We stock only the best brands.
            </p>
          </div>
        </div>
      </div>

      <div className="border-t bg-brand-red-500">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-white">
              © {new Date().getFullYear()} MyExpress Limited. All rights reserved.
            </div>
            <div className="flex items-center space-x-4">
              <a 
                href="https://web.facebook.com/profile.php?id=61570900561396&_rdc=1&_rdr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#1877F2] text-white rounded-full flex items-center justify-center hover:opacity-90 transition-opacity"
                aria-label="Follow us on Facebook"
              >
                <FaFacebookF className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/myexpressltd?igsh=a2Q5cWVrNjRxcHZ1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-[#E4405F] text-white rounded-full flex items-center justify-center hover:opacity-90 transition-opacity"
                aria-label="Follow us on Instagram"
              >
                <FaInstagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;